interface IWhiteList {
  name: string;
  code: string;
  apiDomain: string;
  version: number;
}

export const configVersion = 9;

export const webshopRegex = /https:\/\/.*\.ur\.ch/;
export const scanAccountIdentifier = 'uri';

export const cantonWhitelist = [
  {
    name: 'Fishven Uri',
    code: 'uri',
    apiDomain: 'uri-api.fishven.com',
    version: configVersion,
  },
] as IWhiteList[];
